<div class="fondo">
  <div class="error">Privacidad</div>
  <div class="cuadro1">
    <span class="info">
    Sabemos que tu privacidad y la de tus clientes
    es importante, es por eso que Dungun no guarda ni
    almacena ninguno de tus datos.<br> <br>
    Todas las traducciones son streamings en tiempo real y no
    son almacenadas de ninguna forma por nosotros.
    </span><hr>
    <span class="info">
      We know your client's privacy and yours are important.
      That's why Dungun doesn't save any of your data.<br> <br>
      All translations are streaming in real-time and they
       are not stored in any way by us.
    </span>
  </div>
</div>
